'use client';

import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import Button from '../ui/Button';
import type { FaqSection as FaqSectionType } from '@shared/lib/page-sections/types';

export default function FaqSection({ section }: { section: FaqSectionType }) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const items = section.items || [];
  if (items.length === 0) return null;

  return (
    <section className="w-full px-4 py-10 md:py-14">
      <div className="mx-auto max-w-3xl">
        {section.heading ? (
          <h2 className="mb-6 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            {section.heading}
          </h2>
        ) : null}
        <div className="divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white">
          {items.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div key={idx}>
                <Button
                  raw
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-4 py-3 text-left text-sm font-semibold text-slate-900 hover:bg-slate-50"
                >
                  <span>{item.q}</span>
                  <FaChevronDown
                    className={`h-3 w-3 shrink-0 text-slate-500 transition-transform ${
                      open ? 'rotate-180' : ''
                    }`}
                  />
                </Button>
                {open ? (
                  <div className="border-t border-slate-100 px-4 py-3 text-sm leading-relaxed text-slate-700">
                    {item.a}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
